export enum BlobLocation {
  EVENTS = 0,
  USERS = 1,
  PUBLIC = 2,
  ORGANIZATIONS = 3,
  THEMES = 4
}
